import {ContractTypeModel} from './ContractTypeModel';

import {ProviderModel} from './ProviderModel';
import {RegionModel} from './RegionModel';

export class ContractSettingsModel {
   id: number;
   region: RegionModel;
   contractType: ContractTypeModel;
   provider: ProviderModel;

  constructor(id?: number, contractType?: any, provider?: any, region?: any) {
    this.id = id;
    this.contractType = contractType;
    this.provider = provider;
    this.region = region;
  }

  public static clone(obj: ContractSettingsModel): ContractSettingsModel {
    const result: ContractSettingsModel = new ContractSettingsModel();

    result.contractType = obj.contractType;
    result.region = obj.region;
    result.provider = obj.provider;

    return result;
  }
}
